import { FunctionComponent } from 'react';
import { Link, LinkProps, useSearchParams } from 'react-router-dom';

export const LinkWithSearchParams: FunctionComponent<LinkProps> = (props) => {
  const { to } = props;
  const [searchParams] = useSearchParams();

  const finalTo = typeof to === 'string'
    ? { pathname: to, search: searchParams.toString() }
    : to;

  return <Link {...props} to={finalTo} />;
};
